import React from "react";
import PastOrdersSection from "../component/Order/PastOrdersSection.jsx";
import Header from "../component/layout/Header";
import Footer from "../component/layout/Footer";
import { AiFillStar } from "react-icons/ai";
import { FaStarHalfAlt } from "react-icons/fa";
import vectorimag from "../assets/Vector 9.png";
import starimg from "../assets/star12.png";
import polygon from "../assets/pollygon.png";
import headerimg from "../assets/headerimage.png";
import CustomeSignInPopup from "../component/User/Signup/CustomeSignInPopup.jsx";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function Order() {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  return (
    <div className="flex overflow-hidden flex-col">
      <Header activeLink={"orders"} />
     
      <PastOrdersSection />
      <Footer />
    </div>
  );
}

export default Order;
